export default "__VITE_PUBLIC_ASSET__98acbeea__"